import { useEffect, useState } from 'react';
import { api, type DeviceInfo } from '../api';

export function DevicesPage() {
  const [devices, setDevices] = useState<DeviceInfo[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [removing, setRemoving] = useState<string | null>(null);
  const [rotating, setRotating] = useState(false);
  const [rotateResult, setRotateResult] = useState<string | null>(null);

  useEffect(() => {
    api.devices().then((d) => setDevices(d.devices)).catch((e) => setError(e instanceof Error ? e.message : 'Ошибка'));
  }, []);

  async function handleRemove(hwid: string) {
    if (!window.confirm('Отключить это устройство? Оно потеряет доступ к VPN, пока вы не подключитесь заново.')) {
      return;
    }
    setRemoving(hwid);
    setError(null);
    try {
      const res = await api.removeDevice(hwid);
      setDevices(res.devices);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось отключить устройство');
    } finally {
      setRemoving(null);
    }
  }

  async function handleRotate() {
    if (
      !window.confirm(
        'Сменить ссылку подключения?\n\n' +
          '• Старая ссылка перестанет работать.\n' +
          '• Все устройства отключатся и слетят.\n' +
          '• Нужно будет заново подключиться по новой ссылке на каждом устройстве.\n\n' +
          'Делайте это, если ссылка попала к посторонним.'
      )
    ) {
      return;
    }
    setRotating(true);
    setError(null);
    setRotateResult(null);
    try {
      const res = await api.rotateSubscription();
      setDevices([]);
      setRotateResult(
        `Готово. Ссылка обновлена${res.removedDevices ? `, сброшено устройств: ${res.removedDevices}` : ''}. ` +
          'Откройте раздел «Подписка» и переподключитесь по новой ссылке на каждом устройстве.'
      );
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось сменить ссылку');
    } finally {
      setRotating(false);
    }
  }

  if (error && !devices) return <div className="container"><div className="error">{error}</div></div>;
  if (!devices) return <div className="container">Загрузка…</div>;

  return (
    <div className="container">
      <h1>Устройства</h1>
      <div className="card">
        <p className="muted">Лимит — 4 устройства на подписку. Освободите слот, отключив старое устройство.</p>
        {error ? <div className="error">{error}</div> : null}
        {devices.length === 0 ? (
          <p className="muted">Пока нет подключённых устройств.</p>
        ) : (
          devices.map((d) => (
            <div key={d.hwid} className="row">
              <div>
                <div>{d.platform ?? '—'} {d.deviceModel ?? ''}</div>
                <div className="muted">HWID: <code>{d.hwid.slice(0, 16)}…</code></div>
                {d.osVersion ? <div className="muted">{d.osVersion}</div> : null}
              </div>
              <button
                type="button"
                className="secondary"
                disabled={removing === d.hwid}
                onClick={() => handleRemove(d.hwid)}
              >
                {removing === d.hwid ? 'Отключаем…' : 'Отключить'}
              </button>
            </div>
          ))
        )}
      </div>
      <div className="card">
        <h2>Сменить ссылку подключения</h2>
        <p className="muted">
          Если ссылка <code>connect.orbanvpn.com</code> попала к посторонним — смените её. Старая ссылка перестанет
          работать, все устройства отключатся и их нужно будет переподключить заново по новой ссылке из раздела
          «Подписка». Сменить можно не чаще раза в час.
        </p>
        {rotateResult ? <div className="success">{rotateResult}</div> : null}
        <button type="button" className="secondary" disabled={rotating} onClick={handleRotate}>
          {rotating ? 'Меняем ссылку…' : 'Сменить ссылку'}
        </button>
      </div>
    </div>
  );
}
